<template>
  <div class="app-container">
    <!--加载进度-->
    <van-loading v-if="!isLoaded" class="loading" />
    <!--加载失败-->
    <div v-else-if="errorMessage" class="error-message">
      错误：{{ errorMessage }}
    </div>
    <!--加载成功-->
    <template v-else>
      <van-steps :active="step">
        <van-step>申请信息</van-step>
        <van-step>附件材料</van-step>
      </van-steps>
      <!--表单-->
      <application-form
        v-show="step===0"
        ref="applicationForm"
        :application-info="applicationInfo"
        :is-editable="true"
        action="Update"
        :handle-submit="updateApplication"
      />
      <!--附件-->
      <attachment-list
        v-show="step===1"
        :case-attach-directories="applicationInfo.caseInfo.caseAttachDirectories"
        :is-editable="true"
      />
      <!--按钮-->
      <div class="button-wrap">
        <van-button
          v-if="!isSubmitDisabled"
          type="primary"
          size="large"
          text="修改申请"
          @click="handleUpdate"
        />
        <van-button
          v-if="!isUpdateDisabled"
          type="primary"
          size="large"
          text="提交申请"
          @click="handleSubmit"
        />
      </div>
    </template>
  </div>
</template>

<script>
import { simulateEvent } from '@/utils'
import { ApplicationForm, AttachmentList } from './components'
import {
  getApplicationInfo,
  updateApplicationInfo,
  submitApplicationInfo
} from '@/api/application'
import { Toast } from 'vant'

export default {
  components: {
    ApplicationForm,
    AttachmentList
  },
  data() {
    return {
      isLoaded: false,
      errorMessage: '',
      step: 0,
      applicationInfo: {
        businessTypeId: '',
        businessTypeName: '',
        businessTypeAlias: '',
        businessTypeCode: '',
        aTBusinessTypeCode: '',
        registrationItemId: '',
        registrationItemName: '',
        registrationItemAlias: '',
        registrationItemCode: '',
        applicantName: '',
        applicantIdNumber: '',
        applicantMobilePhone: '',
        remark: '',
        caseInfo: {
          caseAttachDirectories: []
        },
        jJQLRs: [],
        qlrList: [],
        ywrList: [],
        bDCQZH: '', // 产权证号
        bDCDYH: '', // 不动产单元号
        sQZT: '', // 申请主体
        bHNR: '' // 变化内容
      }
    }
  },
  computed: {
    isSubmitDisabled() {
      return this.step === 1
    },
    isUpdateDisabled() {
      return this.step === 0
    }
  },
  watch: {
    step: function() {
      if (this.step === 0) {
        // 允许浏览器回退
        this.$store.dispatch('app/setBackInfo', { allowBack: true })
      } else {
        // 禁止浏览器回退，切换到上一步
        this.$store.dispatch('app/setBackInfo', {
          allowBack: false,
          backHandler: this.handleBack // 处理back
        })
      }
    }
  },
  created() {
    // 加载数据
    this.loadData()
  },
  methods: {
    // 加载数据
    loadData() {
      // 申请信息id
      const id = this.$route.query.id || this.$route.params.id
      getApplicationInfo({
        id,
        eagerLoadingProperties:
          'CaseInfo.CaseAttachDirectories.CaseAttaches,JJQLRs'
      })
        .then(({ data }) => {
          if (data.caseInfo != null) {
            // 案卷附件目录排序
            data.caseInfo.caseAttachDirectories = data.caseInfo.caseAttachDirectories.sort(
              (a, b) => a.orderNo - b.orderNo
            )
            // 案卷附件排序
            data.caseInfo.caseAttachDirectories.forEach(d => {
              d.caseAttaches = d.caseAttaches.sort((a, b) =>
                a.name.localeCompare(b.name)
              )
            })
          }
          Object.assign(this.applicationInfo, data)
          this.applicationInfo.qlrList = this.applicationInfo.jJQLRs.filter(
            j => {
              return j.qLRDIRECT === 0
            }
          )
          this.applicationInfo.ywrList = this.applicationInfo.jJQLRs.filter(
            j => {
              return j.qLRDIRECT === 1
            }
          )
        })
        .catch(error => {
          // 设置错误信息
          this.errorMessage = error.message
        })
        .finally(() => {
          // 设置加载状态为已加载
          this.isLoaded = true
        })
    },
    // 处理提交
    handleSubmit() {
      submitApplicationInfo(this.applicationInfo)
        .then(response => {
          // 提交成功，重定向
          Toast.success({
            message: '提交成功',
            duration: 1000,
            onClose: () => {
              this.$router.replace({
                name: 'ApplicationList',
                params: { status: 'Pending' }
              })
            }
          })
        })
        .catch(error => {
          this.errorMessage = error.message
        })
    },
    // 处理回退
    handleBack() {
      if (this.step > 0) {
        this.step--
      }
    },
    // 处理修改
    handleUpdate() {
      if (this.step === 0) {
        // 验证房屋状态
        this.$refs.applicationForm.getCheckHouseStatus()
      }
    },
    updateApplication() {
      // 修改申请信息
      updateApplicationInfo(this.applicationInfo)
        .then(response => {
          Toast.success({ message: '修改成功' })
          // 跳到附件页面
          this.step++
          // 模拟滚动事件，解决图片异步懒加载的bug
          this.$nextTick(() => {
            simulateEvent(this.$el, 'scroll')
          })
        })
        .catch(error => {
          this.errorMessage = error.message
        })
    }
  }
}
</script>

<style scoped lang="scss">
.app-container {
  min-height: 100vh;
  background-color: #ededed;
  .loading {
    padding-top: 15px;
    text-align: center;
  }
  .error-message {
    color: #ee0a24;
    padding-top: 15px;
    text-align: center;
  }
  .button-wrap {
    margin-top: 15px;
    padding: 0 15px 15px 15px;
  }
}
</style>
